import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';
import { throwUnlessApiSuccess } from '../utils/apiResponse';

export const FETCH_PLAYERS_REQUEST = 'FETCH_PLAYERS_REQUEST';
export const FETCH_PLAYERS_SUCCESS = 'FETCH_PLAYERS_SUCCESS';
export const FETCH_PLAYERS_FAILURE = 'FETCH_PLAYERS_FAILURE';
export const CREATE_PLAYER_SUCCESS = 'CREATE_PLAYER_SUCCESS';
export const UPDATE_PLAYER_SUCCESS = 'UPDATE_PLAYER_SUCCESS';
export const DELETE_PLAYER_SUCCESS = 'DELETE_PLAYER_SUCCESS';
export const TOGGLE_LOCK_PLAYER_SUCCESS = 'TOGGLE_LOCK_PLAYER_SUCCESS';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;

export const getPlayers = () => async (dispatch) => {
  dispatch({ type: FETCH_PLAYERS_REQUEST });
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const response = await axios.post(`${base_url}`, {
      apiName: 'player',
      command: 'getPlayers',
      loggedInUserRole,
      loggedInUsername
    });
    dispatch({
      type: FETCH_PLAYERS_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_PLAYERS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch players'
    });
  }
};

export const createPlayer = (playerData) => async (dispatch) => {
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const response = await axios.post(`${base_url}`, {
      apiName: 'player',
      command: 'createPlayer',
      loggedInUserRole,
      ...playerData
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({
      type: CREATE_PLAYER_SUCCESS,
      payload: data
    });
    return response.data;
  } catch (error) {
    console.error('Failed to create player:', error);
    throw error;
  }
};

export const updatePlayer = (playerId, updateData) => async (dispatch) => {
  try {
      if (!playerId) {
          throw new Error('Player id is required');
      }
      const loggedInUserRole = getLoggedInUserRole();
      const { command: overrideCommand, ...fields } = updateData || {};
      const response = await axios.post(`${base_url}`, {
          apiName: 'player',
          command: overrideCommand || 'updatePlayer',
          playerId,
          updateData: fields,
          loggedInUserRole,
      });
      const data = throwUnlessApiSuccess(response);
      dispatch({
          type: UPDATE_PLAYER_SUCCESS,
          payload: data
      });
      return response.data;
  } catch (error) {
      console.error('Failed to update player:', error);
      throw error;
  }
};


export const deletePlayer = (playerId) => async (dispatch) => {
  try {
    await axios.post(`${base_url}`, {
      apiName: 'player',
      command: 'deletePlayer',
      playerId
    });
    dispatch({
      type: DELETE_PLAYER_SUCCESS,
      payload: playerId
    });
  } catch (error) {
    console.error('Failed to delete player:', error);
    throw error;
  }
};

export const toggleLockPlayer = (playerId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'player',
      command: 'toggleLockPlayer',
      playerId
    });
    dispatch({
      type: TOGGLE_LOCK_PLAYER_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const bulkUpdateAllowedWin = (allowed_win) => async () => {
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const response = await axios.post(`${base_url}`, {
      apiName: 'player',
      command: 'bulkUpdateAllowedWin',
      allowed_win,
      loggedInUserRole,
    });
    return throwUnlessApiSuccess(response);
  } catch (error) {
    console.error('Failed to bulk update Allowed Win:', error);
    throw error;
  }
};